import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ContactRound, Plus, X, Phone, Smartphone, Mail } from "lucide-react";
import { CARGO_SUGERIDOS } from "./constants";

export default function ContatosEditor({ form, addContato, updateContato, removeContato }) {
  return (
    <div className="sm:col-span-2 space-y-2" data-testid="contatos-section">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <Label className="flex items-center gap-1.5 mb-0">
          <ContactRound className="w-4 h-4 text-primary" />
          Contatos do condomínio
          <span className="text-xs text-muted-foreground font-normal">
            ({(form.contatos || []).length})
          </span>
        </Label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={addContato}
          data-testid="btn-add-contato"
        >
          <Plus className="w-3.5 h-3.5 mr-1.5" /> Novo contato
        </Button>
      </div>

      {(form.contatos || []).length === 0 && (
        <div className="rounded-md border border-dashed border-border p-4 text-center text-xs text-muted-foreground">
          Nenhum contato cadastrado. Clique em <strong>“Novo contato”</strong> para adicionar
          síndico, zelador, administradora ou outros responsáveis.
        </div>
      )}

      <div className="space-y-3">
        {(form.contatos || []).map((c, idx) => (
          <div
            key={c.id}
            className="rounded-lg border border-border bg-muted/30 p-3 space-y-2 relative"
            data-testid={`contato-item-${idx}`}
          >
            <div className="flex items-center justify-between gap-2">
              <Badge variant="outline" className="text-[10px]">
                Contato #{idx + 1}
              </Badge>
              <Button
                type="button"
                size="icon"
                variant="ghost"
                onClick={() => removeContato(c.id)}
                className="h-7 w-7"
                data-testid={`btn-remove-contato-${idx}`}
                title="Remover contato"
              >
                <X className="w-3.5 h-3.5 text-red-500" />
              </Button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <div className="space-y-1">
                <Label className="text-[11px]">Nome</Label>
                <Input
                  value={c.nome}
                  onChange={(e) => updateContato(c.id, "nome", e.target.value)}
                  placeholder="Ex: Sr. Roberto Almeida"
                  data-testid={`contato-nome-${idx}`}
                />
              </div>
              <div className="space-y-1">
                <Label className="text-[11px]">Cargo / Função</Label>
                <Select
                  value={c.cargo || "__none__"}
                  onValueChange={(v) => updateContato(c.id, "cargo", v === "__none__" ? "" : v)}
                >
                  <SelectTrigger data-testid={`contato-cargo-${idx}`}>
                    <SelectValue placeholder="Escolha ou deixe em branco" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="__none__">— não especificado</SelectItem>
                    {CARGO_SUGERIDOS.map((cg) => (
                      <SelectItem key={cg} value={cg}>{cg}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-1">
                <Label className="text-[11px] flex items-center gap-1">
                  <Phone className="w-3 h-3 text-muted-foreground" /> Telefone fixo
                </Label>
                <Input
                  value={c.telefone}
                  onChange={(e) => updateContato(c.id, "telefone", e.target.value)}
                  placeholder="(11) 3000-0000"
                  data-testid={`contato-telefone-${idx}`}
                />
              </div>
              <div className="space-y-1">
                <Label className="text-[11px] flex items-center gap-1">
                  <Smartphone className="w-3 h-3 text-muted-foreground" /> Celular / WhatsApp
                </Label>
                <Input
                  value={c.celular}
                  onChange={(e) => updateContato(c.id, "celular", e.target.value)}
                  placeholder="(11) 98888-7777"
                  data-testid={`contato-celular-${idx}`}
                />
              </div>
              <div className="sm:col-span-2 space-y-1">
                <Label className="text-[11px] flex items-center gap-1">
                  <Mail className="w-3 h-3 text-muted-foreground" /> E-mail
                </Label>
                <Input
                  type="email"
                  value={c.email}
                  onChange={(e) => updateContato(c.id, "email", e.target.value)}
                  placeholder="contato@condominio.com"
                  data-testid={`contato-email-${idx}`}
                />
              </div>
              <div className="sm:col-span-2 space-y-1">
                <Label className="text-[11px]">Observação sobre o contato</Label>
                <Input
                  value={c.observacao}
                  onChange={(e) => updateContato(c.id, "observacao", e.target.value)}
                  placeholder="Ex: Atende só depois das 14h"
                  data-testid={`contato-obs-${idx}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
